// import store from "@/store";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import { _lang } from '@/utils/lang'
import { _langforSpark } from '@/utils/langforSpark';
import secretsparkshort from '@/views/secretsparkshort/index.vue';
import readmesparkshort from '@/views/readmesparkshort/index.vue';

const routes: Array<RouteRecordRaw> = [
  // {
  //   path: "/",
  //   name: "ROOT",
  //   redirect: "/home",
  // },
  {
    path: "/home",
    name: "HOME",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/home/index.vue")
  },
  {
    path: "/issue",
    name: "ISSUE",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/issue/index.vue"),
    meta: {
      title: _lang('FEEDBACK'),
    },
  },
  {
    path: "/feedBacks",
    name: "Message",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/feedBacks/index.vue"),
    meta: {
      title: _lang('Message'),
    },
  },
  {
    path: "/welfare",
    name: "WELFARE",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/welfare/index.vue"),
    meta: {
      title: 'WELFARE',
    },
  },
  {
    path: "/share",
    name: "SHARE",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/share/index.vue"),
    meta: {
      title: 'SHARE',
    },
  },
  {
    path: "/page",
    name: "PAGE",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/page/index.vue"),
    meta: {
      title: 'PAGE',
    },
  },
  {
    path: "/secret",
    name: "SECRET",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/secret/index.vue"),
    meta: {
      title: _lang('privacyPolicy'),
    },
  },
  
  {
    path: "/readme",
    name: "README",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/readme/index.vue"),
    meta: {
      title: _lang('termsServices'),
    },
  },

  {
    path: "/",
    name: "sereal",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/website/index.vue"),
    meta: {
      title: 'Sereal',
    },
  },
  {
    path: "/PrivacyPolicy",
    name: "PrivacyPolicy",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/PrivacyPolicy/index.vue"),
    meta: {
      title: 'Privacy Policy',
    },
  },
  {
    path: "/TermsofService",
    name: "TermsofService",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/TermsofService/index.vue"),
    meta: {
      title: 'Terms of Service',
    },
  },
  {
    path: "/evaluate",
    name: "EVALUATE",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/evaluate/index.vue"),
    meta: {
      title: _lang('Rating'),
    },
  },
  {
    path: "/hallowmas",
    name: "HALLOWMAS",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/hallowmas/index.vue"),
    meta: {
      title: _lang('Halloween'),
    },
  },
  {
    path: "/questionnaire",
    name: "WELCOME",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/questionnaire/index.vue"),
    meta: {
      title: _lang('Survey'),
    },
  },
  {
    path: "/questionnaire/question",
    name: "FILL Survey",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/questionnaire/question.vue"),
    meta: {
      title: _lang('Survey'),
    },
  },
  {
    path: "/questionnaire/thanks",
    name: "THANKS",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/questionnaire/thanks.vue"),
    meta: {
      title: _lang('Survey'),
    },
  },{
    path: "/secretSparkShort",
    name: "SECRETSPARKSHORT",
    component: secretsparkshort,
    // () =>
    //   import(/* webpackChunkName: "Charpter" */ "../views/secretsparkshort/index.vue"),
    meta: {
      title: _langforSpark('privacyPolicy'),
    },
  },
  {
    path: "/readmeSparkShort",
    name: "READMESPARKSHORT",
    component: readmesparkshort,
    // () =>
    //   import(/* webpackChunkName: "Charpter" */ "../views/readmesparkshort/index.vue"),
    meta: {
      title: _langforSpark('termsServices'),
    },
  },
  {
    path: "/bottomPage",
    name: "BOTTOMPAGE",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/bottomPage/index.vue"),
    meta: {
      title: _lang('bottomPagetit'),
    },
  },
  {
    path: "/Thanksgiving",
    name: "THANKSGIVING",
    component: () =>
      import(/* webpackChunkName: "Charpter" */ "../views/Thanksgiving/index.vue"),
    meta: {
      title: `💘 Valentine's Special: Sweet Shorts & Lucky Spins! 💘`,
    },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

router.beforeEach((to, from, next) => {
  //beforeEach是router的钩子函数，在进入路由前执行
  if (to.meta.title) {
    //判断是否有标题
    document.title = to.meta.title as string
  } else {
    document.title = ''
  }
  next()
})

export default router;
